import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import { COLOR_PRESETS } from "../../core/constants";

function AnnouncementBarPreview({
  position = "TOP",
  displayType = "TEXT",
  message = "Miễn phí giao hàng cho đơn hàng đầu tiên",
  ctaText = "Mua ngay",
  allowClose = true,
  iconMode = "PRESET",
  iconPresetCode = "truck",
  iconURL = "",
  backgroundMode = "PRESET",
  colorPresetCode = "green_mint",
  backgroundColor = "#00a86b",
  gradientFromColor = "#ff6a00",
  gradientToColor = "#ee0979",
  gradientAngle = 90,
  textColor = "#ffffff",
  iconColor = "#ffffff",
  buttonColor = "#ffffff",
  buttonTextColor = "#ee0979",
  imageURL = "",
}) {
  const isBottom = position === "BOTTOM";

  // Bo tròn viền dưới nếu trên top, bo tròn viền trên nếu dưới bottom
  const barBorderRadius = isBottom
    ? {
        borderTopLeftRadius: "12px",
        borderTopRightRadius: "12px",
        borderBottomLeftRadius: "0px",
        borderBottomRightRadius: "0px",
      }
    : {
        borderBottomLeftRadius: "12px",
        borderBottomRightRadius: "12px",
        borderTopLeftRadius: "0px",
        borderTopRightRadius: "0px",
      };

  // Resolve background style
  let bgStyle = {};
  if (displayType === "IMAGE") {
    bgStyle = {
      backgroundColor: "#f5f5f5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    };
  } else if (backgroundMode === "PRESET") {
    const preset = COLOR_PRESETS.find((p) => p.code === colorPresetCode) || COLOR_PRESETS[0];
    bgStyle = { backgroundColor: preset.background };
  } else if (backgroundMode === "SOLID" || backgroundMode === "CUSTOM_COLOR") {
    bgStyle = { backgroundColor: backgroundColor || "#00a86b" };
  } else if (backgroundMode === "GRADIENT") {
    bgStyle = {
      background: `linear-gradient(${gradientAngle || 90}deg, ${gradientFromColor || "#ff6a00"}, ${
        gradientToColor || "#ee0979"
      })`,
    };
  }

  // Resolve icon
  const renderIcon = () => {
    if (iconMode === "NONE") return null;
    if (iconMode === "UPLOAD" && iconURL) {
      return (
        <img
          src={iconURL}
          alt="icon"
          style={{ width: "18px", height: "18px", objectFit: "contain", marginRight: "6px" }}
        />
      );
    }
    const iconGlyphs = {
      gift: "🎁",
      voucher: "🎟️",
      discount: "🏷️",
      truck: "🚚",
      flash_sale: "⚡",
      hot: "🔥",
      clock: "⏰",
      speaker: "📢",
      sparkle: "⭐",
      tag: "🔖",
      shield: "🛡️",
    };
    const glyph = iconGlyphs[iconPresetCode] || "📢";
    return (
      <span
        style={{
          marginRight: "6px",
          fontSize: "14px",
          display: "inline-flex",
          alignItems: "center",
          color: iconColor,
        }}
      >
        {glyph}
      </span>
    );
  };

  const renderBarContent = () => {
    if (displayType === "IMAGE") {
      return (
        <div
          style={{
            minHeight: "44px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "#f0f0f0",
            overflow: "hidden",
            boxShadow: isBottom ? "0 -2px 6px rgba(0,0,0,0.06)" : "0 2px 6px rgba(0,0,0,0.06)",
            ...barBorderRadius,
          }}
        >
          {imageURL ? (
            <img
              src={imageURL}
              alt="Announcement Bar"
              style={{ width: "100%", height: "auto", display: "block", ...barBorderRadius }}
            />
          ) : (
            <span style={{ fontSize: "12px", color: "#999999", padding: "12px" }}>Ảnh Announcement Bar (1125x90)</span>
          )}
        </div>
      );
    }

    return (
      <div
        style={{
          padding: "8px 12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "8px",
          minHeight: "40px",
          overflow: "hidden",
          boxShadow: isBottom ? "0 -2px 6px rgba(0,0,0,0.06)" : "0 2px 6px rgba(0,0,0,0.06)",
          ...bgStyle,
          ...barBorderRadius,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flex: 1,
            fontSize: "12px",
            fontWeight: 500,
            color: textColor || "#ffffff",
            lineHeight: "16px",
            overflow: "hidden",
          }}
        >
          {renderIcon()}
          <span
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {message || "Nội dung thông báo"}
          </span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexShrink: 0 }}>
          {ctaText && (
            <button
              type="button"
              style={{
                backgroundColor: buttonColor || "#ffffff",
                color: buttonTextColor || "#ee0979",
                border: "none",
                borderRadius: "12px",
                padding: "3px 10px",
                fontSize: "11px",
                fontWeight: 600,
                cursor: "pointer",
                boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
                whiteSpace: "nowrap",
              }}
            >
              {ctaText}
            </button>
          )}

          {allowClose && (
            <CloseOutlined
              style={{
                color: textColor || "#ffffff",
                fontSize: "11px",
                cursor: "pointer",
                opacity: 0.85,
              }}
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "8px",
        border: "1px solid #e0e0e0",
        padding: "16px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
      }}
    >
      <div
        style={{
          fontWeight: 600,
          fontSize: "13px",
          marginBottom: "12px",
          color: "#212529",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Xem trước trên App</span>
        <span style={{ fontSize: "11px", color: "#8c8c8c", fontWeight: 400 }}>
          Màn Trang chủ • {isBottom ? "Cuối màn (Footer)" : "Đầu màn (Header)"}
        </span>
      </div>

      {/* App frame simulator */}
      <div
        style={{
          border: "1px solid #d9d9d9",
          borderRadius: "8px",
          overflow: "hidden",
          backgroundColor: "#f7f8fa",
          display: "flex",
          flexDirection: "column",
          minHeight: "180px",
        }}
      >
        {/* Fake app search bar */}
        <div
          style={{
            padding: "8px 12px",
            backgroundColor: "#ffffff",
            borderBottom: "1px solid #eeeeee",
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          <div
            style={{
              height: "28px",
              flex: 1,
              borderRadius: "14px",
              backgroundColor: "#f0f2f5",
              display: "flex",
              alignItems: "center",
              padding: "0 12px",
              fontSize: "11px",
              color: "#999999",
            }}
          >
            Tìm kiếm sản phẩm...
          </div>
        </div>

        {/* TOP Announcement Bar */}
        {!isBottom && renderBarContent()}

        {/* Fake app content area */}
        <div style={{ padding: "16px", flex: 1, backgroundColor: "#fafafa" }}>
          <div
            style={{
              height: "12px",
              backgroundColor: "#e8e8e8",
              borderRadius: "4px",
              width: "60%",
              marginBottom: "8px",
            }}
          />
          <div
            style={{
              height: "12px",
              backgroundColor: "#eeeeee",
              borderRadius: "4px",
              width: "80%",
              marginBottom: "8px",
            }}
          />
          <div
            style={{
              height: "12px",
              backgroundColor: "#f0f0f0",
              borderRadius: "4px",
              width: "45%",
            }}
          />
        </div>

        {/* BOTTOM Announcement Bar */}
        {isBottom && renderBarContent()}
      </div>

      <div style={{ fontSize: "11px", color: "#8c8c8c", marginTop: "8px", textAlign: "center" }}>
        Preview cập nhật realtime theo vị trí, nội dung, icon, màu, điều hướng.
      </div>
    </div>
  );
}

export default React.memo(AnnouncementBarPreview);
